import { Controller } from "@hotwired/stimulus"

// Opens a custom <dialog>-based modal for an expense approval action (reject
// with a reason, or request more information). Unlike the delete modal, the
// dialog wraps a real form that POSTs a body, so this controller only handles
// opening/closing — submission is a native form submit.
export default class extends Controller {
  static targets = ["dialog"]

  open(event) {
    event.preventDefault()
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  backdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  keydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
